import { Link } from "react-router-dom";
import { Icon } from "./icons";
import "./legal.style.css";

const MentionsLegales = () => (
  <div className="legal-page">
    <Link to="/" className="legal-back">
      ← Retour à l’accueil
    </Link>
    <h1>Mentions légales</h1>
    <p className="legal-lead">
      Informations légales concernant l’éditeur et l’hébergement de ce site.
    </p>
    <p className="legal-updated">
      <Icon name="calendar" /> Dernière mise à jour · septembre 2026
    </p>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="user" />
      </div>
      <div className="legal-section-body">
        <h2>Éditeur du site</h2>
        <div className="legal-card">
          <p className="legal-row">
            <strong>Centre Esthétique Basilix</strong>
          </p>
          <p className="legal-row">
            Avenue Charles-Quint 420, 1082 Berchem-Sainte-Agathe (Bruxelles),
            Belgique
          </p>
          <p className="legal-row">
            E-mail :{" "}
            <a href="mailto:esthetiquebasilix@gmail.com">
              esthetiquebasilix@gmail.com
            </a>
          </p>
          <p className="legal-row">
            Téléphone : <a href="tel:+3223545798">+32 2 354 57 98</a>
          </p>
        </div>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="layers" />
      </div>
      <div className="legal-section-body">
        <h2>Hébergement</h2>
        <p>Le site et ses services sont hébergés par :</p>
        <ul>
          <li>
            Site (front-end) : Netlify, Inc. — 512 2nd Street, Suite 200, San
            Francisco, CA 94107, États-Unis
          </li>
          <li>
            API (back-end) : Render Services, Inc. — 525 Brannan Street, Suite
            300, San Francisco, CA 94107, États-Unis
          </li>
          <li>
            Base de données : MongoDB Atlas (MongoDB, Inc.) — 1633 Broadway, New
            York, NY 10019, États-Unis
          </li>
        </ul>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="shield" />
      </div>
      <div className="legal-section-body">
        <h2>Propriété intellectuelle</h2>
        <p>
          L’ensemble du contenu de ce site (textes, images, logo, éléments
          graphiques) est protégé par le droit d’auteur. Toute reproduction,
          totale ou partielle, sans autorisation préalable est interdite.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="cookie" />
      </div>
      <div className="legal-section-body">
        <h2>Données personnelles &amp; cookies</h2>
        <p>
          Le traitement de vos données personnelles est décrit dans notre{" "}
          <Link to="/politique-confidentialite">Politique de confidentialité</Link>
          , et l’usage des cookies dans notre{" "}
          <Link to="/politique-cookies">Politique de cookies</Link>.
        </p>
      </div>
    </section>
  </div>
);

export default MentionsLegales;
